module.exports = __webpack_public_path__ + "img/help-ot4.b75d17b4.png";